export default __webpack_public_path__ + "static/media/slider_image_03-sm@2x.6bbc250d.jpg";